import { atom } from "jotai";
import type { ReflectionResponse } from "../types";

export const generalFeelingAtom = atom<number>(0);
export const dayDescriptionAtom = atom<string>("");
export const selectedReflectionsAtom = atom<string | null>(null);
export const reflectionResponsesAtom = atom<Record<string, ReflectionResponse>>(
	{},
);

export const isFormValidAtom = atom<boolean>((get) => {
	const generalFeeling = get(generalFeelingAtom);
	const dayDescription = get(dayDescriptionAtom);
	return (
		[3, 1, -1, -3].includes(generalFeeling) && dayDescription.trim().length > 0
	);
});
